




























import { Vue, Component, Prop } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";

import AgDataTableRow from "./AgDataTableRow.vue";

export type AgDataTableRowMenuOptions = {
  label: string;
  icon: string;
  class?: string | string[];
  link?: string;
  append?: boolean;
  replace?: boolean;
  action?: (item: any, column?: AgDataTableColumnOptions) => void;
  disabled?: (item: any, column?: AgDataTableColumnOptions) => boolean;
};

export type AgDataTableColumnOptions =
  | {
      type: "LINK";
      to: string;
      append?: boolean;
      replace?: boolean;
      transform?: (val: any) => string;
    }
  | {
      type: "CHIP";
      label: boolean;
      color: { [key: string]: string };
      transform?: (val: any) => string;
      tooltip?: boolean;
      tooltipContent?: (val: any) => string;
    }
  | {
      type: "OPTIONS";
      options: AgDataTableRowMenuOptions[];
    }
  | {
      type: "TEXT";
      transform?: (val: any) => string;
      tooltip?: boolean;
      tooltipContent?: (val: any) => string;
    }
  | { type: "INDEX" };

export type AgDataTableOptions = {
  header: DataTableHeader;
  row: AgDataTableColumnOptions;
};

@Component({
  components: {
    AgDataTableRow
  }
})
export default class AgDataTable extends Vue {
  @Prop()
  options!: AgDataTableOptions[];

  @Prop()
  items!: any[];

  @Prop({ default: "id" })
  rowKey!: string;

  @Prop({ default: true })
  loading!: boolean;

  get tableHeaders() {
    return this.options.map(item => {
      return item.header;
    });
  }
}
